const _excluded = ["onChange"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useRef } from 'react';
import { Controller, useWatch } from 'react-hook-form';
import { InfoIcon, MenuItem, TextField, Typography, useDidUpdate } from 'seagull';
import { richTextValidation } from 'validators';
import { connectControllerToTextField } from "../../../utils/react-hook-form.utils";
import styles from "./IntroductoryMessageEditor.module.scss";

/** This component is meant to work exclusively with `react-hook-form`.
 * It's your responsibility to provide the form field name keys (which probably correspond to the template names in some way).
 * Each template's text content (= value) is provided by the containing form. */
export default function IntroductoryMessageEditor(_ref) {
  let {
    formState,
    control,
    selectedTemplateFormFieldName,
    label = 'Introductory message templates',
    templates,
    onStartEditingReadOnlyTemplate,
    testPrefix = 'intro-message-editor'
  } = _ref;
  const selectedTemplateName = useWatch({
    control,
    name: selectedTemplateFormFieldName
  });
  const refs = useRef({});
  useDidUpdate(() => {
    var _refs$current$selecte;

    const target = (_refs$current$selecte = refs.current[selectedTemplateName]) === null || _refs$current$selecte === void 0 ? void 0 : _refs$current$selecte.querySelector('textarea');

    if (target) {
      // a hack to move the cursor to the end
      const currentValue = target.value;
      target.value = '';
      target.value = currentValue;
    }

    target === null || target === void 0 ? void 0 : target.focus();
  }, [selectedTemplateName]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.fieldWithTooltip
  }, /*#__PURE__*/React.createElement(Typography, null, label), /*#__PURE__*/React.createElement(InfoIcon, {
    info: "This message will show as an introductory message on the agreement and the email your client receives."
  })), /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: selectedTemplateFormFieldName,
    render: props => /*#__PURE__*/React.createElement(TextField, _extends({}, connectControllerToTextField(props), {
      disabled: !formState.isValid,
      "data-testid": "".concat(testPrefix, "-dropdown"),
      select: true
    }), templates.map((_ref2, i) => {
      let {
        dropdownLabel,
        name
      } = _ref2;
      return /*#__PURE__*/React.createElement(MenuItem, {
        key: name,
        value: name,
        "data-testid": "".concat(testPrefix, "-dropdown-option-").concat(i)
      }, dropdownLabel);
    }))
  }), templates.map(_ref3 => {
    let {
      name
    } = _ref3;
    return /*#__PURE__*/React.createElement("div", {
      hidden: selectedTemplateName !== name,
      key: name,
      style: {
        gridColumn: 'span 2'
      },
      ref: el => {
        return refs.current && (refs.current[String(name)] = el);
      }
    }, /*#__PURE__*/React.createElement(Controller, {
      control: control,
      name: name,
      rules: richTextValidation(),
      render: props => {
        const _connectControllerToT = connectControllerToTextField(props),
              {
          onChange: _onChange
        } = _connectControllerToT,
              connect = _objectWithoutProperties(_connectControllerToT, _excluded);

        return /*#__PURE__*/React.createElement(TextField, _extends({}, connect, {
          onChange: e => {
            const template = templates.find(_ref4 => {
              let {
                name
              } = _ref4;
              return name === selectedTemplateName;
            });

            if (template !== null && template !== void 0 && template.readOnly) {
              onStartEditingReadOnlyTemplate && onStartEditingReadOnlyTemplate(name);
            } else {
              _onChange(e);
            }
          },
          "data-testid": "".concat(testPrefix, "-").concat(name),
          placeholder: "Your message\u2026",
          multiline: true,
          minRows: 6,
          maxRows: 12
        }));
      }
    }));
  }));
}